import createCrudVuexModule from "@/store/crud";

export const reportTemplate = createCrudVuexModule({
  namespaced: true,
  path: "/library/report-template",
});

export const managementReportTemplate = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/report-template",
});
